<template>
  <v-app id="app">
    <v-layout style="padding-top:5%" justify-center>
      <v-card
        outlined
        style="height: min-content; max-width: 500px; width: 100%;"
        flat
      >
        <div style="overflow:hidden">
          <v-layout row justify-center class="pt-2">
            <img
              class="mx-5 px-5 pt-5 mt-5"
              style="width: 90%; max-height: 300px; object-fit: contain;"
              src="https://storage.googleapis.com/onechart-prod/themes/patient/login.png"
            />
          </v-layout>
          <v-layout class="pt-4 pb-4" justify-center row>
            <span
              style="max-width: 300px; text-size:13px; text-align: center; color: #909090"
              >Powered by OneChart Health
            </span>
          </v-layout>
          <v-card-text row>
            <p><span>May 6, 2022</span></p>
            <p>
              On November 24, 2020, SmartChoice MRI ceased operations.
              SmartChoice MRI patients needing a copy of their medical records
              should contact
              <a href="https://rayusradiology.com">RAYUS Radiology</a>.
            </p>
            <p>
              Thank you,<br />
              OneChart Health
            </p>
          </v-card-text>
        </div>
        <div
          style="position: absolute; bottom:-25px; right: 3px; opacity:0.5; font-size:12px;"
        >
          0.9.8.0
        </div>
      </v-card>
    </v-layout>
  </v-app>
</template>

<script>
export default {};
</script>
